import { css } from 'styled-components'
import * as R from 'remeda'
import { typography } from '../../theme/tokens'

const generatedTextStyles = { ...typography.Base, ...typography.Component }

export type TextStyle = keyof typeof generatedTextStyles

export const getTextStyleCss = (textStyle: TextStyle) => {
  const properties = generatedTextStyles[textStyle]
  return css`
    ${R.entries(properties).map(([key, value]) => {
      return `${R.toKebabCase(key)}: ${value};`
    })}
  `
}
